import { PaginationResponse } from '@repo/ui/data-table'

import { TeachingHallComment } from '../../../lib/types/models/ol/teaching-hall-comment/teaching-hall-comment'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getTeachingHallComment(data: { commentId: number; teachingHallId: number }) {
  return restApiClient
    .url(constructApiUrl(API.teachingHallComments.get.url, data))
    .get<TeachingHallComment>()
}

export function getAllTeachingHallComments(data: { teachingHallId: number }) {
  return restApiClient
    .url(constructApiUrl(API.teachingHallComments.getAll.url, data))
    .get<PaginationResponse<TeachingHallComment>>()
}
